<template lang="pug">
  <div>
    v-app-bar(
      v-if="!showToolbarAndNavDrawer"
      :color="color"
      height="48px;"
      dark
    )
      img(
        :src="logo" 
        height="26"
        @click="$router.push('/')" 
        style="cursor: pointer;"
      )

  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "HeaderApproval",
  props: {
    color: String,
    logo: String
  },
  computed: {
    showToolbarAndNavDrawer() {
      if (this.$route.path.match(/^\/page-approval/g)) return false;
      if (!this.$store.getters.isAuthenticated) return false;
      return true;
    },
  },
};
</script>
  